/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyInterviewTypename = "PharmacyInterview" as const;

/**
 *
 * @export
 * @interface PharmacyInterview
 */
export interface PharmacyInterview {
  /**
   *
   * @type {object}
   * @memberof PharmacyInterview
   */
  questionnaires: object;
  /**
   *
   * @type {number}
   * @memberof PharmacyInterview
   */
  version: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyInterview
   */
  readonly __typename?: string;
}

export function PharmacyInterviewFromJSON(json: any): PharmacyInterview {
  return PharmacyInterviewFromJSONTyped(json, false);
}

export function PharmacyInterviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): PharmacyInterview {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyInterviewTypename,

    questionnaires: json["questionnaires"],
    version: json["version"],
  };
}

export function PharmacyInterviewToJSON(object?: PharmacyInterview | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    questionnaires: value.questionnaires,
    version: value.version,
  };
}
